/**
 * Fallback affiché pendant le chargement d'un chunk de route lazy (`React.lazy`
 * + Suspense, sprint-30 A5). Volontairement **léger et autonome** : tout import
 * lourd ici (chart, carte…) réintroduirait dans le chunk initial ce que le
 * code-splitting cherche à en sortir. Palette et pattern a11y (`role="status"`
 * + `aria-live`) alignés sur les états de chargement existants.
 */
export function RouteFallback(): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[40vh] items-center justify-center gap-3 text-sm text-slate-600"
    >
      <span
        aria-hidden="true"
        className="h-6 w-6 animate-spin rounded-full border-2 border-amber-500 border-t-transparent"
      />
      <span className="sr-only">Chargement…</span>
    </div>
  );
}
